import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";

const BankDetails = ({
  onClickNext,
  onClickPrevious,
  onClickCancel,
  clientDetails,
  goToPage,
}) => {
  const [loading, setLoading] = useState();
  const [bankName, setBankName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [nameAsbank, setNameasBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [revenueAccNumber, setRevenueAccNumber] = useState("");
  const [debitorAccNumber, setDebitorAccNumber] = useState("");
  const [revenueAccIfsc, setRevenueAccIfsc] = useState("");
  const [debitorAccIfsc, setDebitorAccIfsc] = useState("");
  const [corporateId, setCorporateId] = useState("");
  const [userId, setUserId] = useState("");
  const [showDebitorAccountDetails, setShowDebitorAccountDetails] =
    useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const reduxData = useSelector((state) => state.addService);

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
  };
  const containerStyle = {
    width: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };
  const clientService = clientDetails?.service;

  for (const servicesOfClient of clientService) {
    if (
      reduxData?.service?.serviceType?.toLowerCase() === "van" ||
      reduxData?.service?.serviceType?.toLowerCase() === "payin" ||
      reduxData?.service?.serviceType?.toLowerCase() === "van-upi"
    ) {
      if (
        servicesOfClient?.serviceType?.toLowerCase() === "van" ||
        servicesOfClient?.serviceType?.toLowerCase() === "payin" ||
        servicesOfClient?.serviceType?.toLowerCase() === "voucher"
      ) {
        goToPage(5);
      }
    }
    if (reduxData?.service?.serviceType?.toLowerCase() === "van-upi") {
      if (
        servicesOfClient?.serviceType?.toLowerCase() === "van" ||
        servicesOfClient?.serviceType?.toLowerCase() === "payin" ||
        servicesOfClient?.serviceType?.toLowerCase() === "voucher"
      ) {
        goToPage(6);
      }
    }
    if (reduxData?.service?.serviceType?.toLowerCase() === "voucher") {
      if (
        servicesOfClient?.serviceType?.toLowerCase() === "van" ||
        servicesOfClient?.serviceType?.toLowerCase() === "payin" ||
        servicesOfClient?.serviceType?.toLowerCase() === "van-upi"
      ) {
        goToPage(6);
      }
    }
    if (
      reduxData?.service?.serviceProviderName?.toLowerCase() === "cashfree" ||
      reduxData?.service?.serviceProviderName?.toLowerCase() === "eskay"
    ) {
      if (
        servicesOfClient?.serviceProviderName?.toLowerCase() === "cashfree" ||
        servicesOfClient?.serviceProviderName?.toLowerCase() === "eskay"
      ) {
        goToPage(5);
      }
    }
  }

  useEffect(() => {
    if (
      reduxData?.service?.serviceType === "payin" ||
      reduxData?.service?.serviceType === "van" ||
      reduxData?.service?.serviceType === "voucher"
    ) {
      if (
        reduxData?.bankAccountNumber !== "" &&
        reduxData?.bankIfscCode !== "" &&
        reduxData?.nameAsbank !== ""
      ) {
        setBankName(reduxData?.bankName);
        setBankAccountNumber(reduxData?.bankAccountNumber);
        setIfscCode(reduxData?.bankIfscCode);
        setNameasBank(reduxData?.nameAsPerBank);
      }
    } else if (reduxData?.service?.serviceType === "payout") {
      if (
        reduxData?.service?.serviceProviderName?.toUpperCase() === "EQUITAS" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO"
      ) {
        setShowDebitorAccountDetails(true);
        setDebitorAccIfsc(reduxData?.debitorAccIfsc);
        setDebitorAccNumber(reduxData?.debitorAccNumber);
        setRevenueAccIfsc(reduxData?.revenueAccIfsc);
        setRevenueAccNumber(reduxData?.revenueAccNumber);
        setCorporateId(reduxData.corpId);
        setUserId(reduxData?.debUserId);
      }

      if (
        reduxData?.remitterAccountNumber !== "" &&
        reduxData?.remitterIfscCode !== "" &&
        reduxData?.remitterNameAsPerBank !== ""
      ) {
        setBankName(reduxData?.bankName);
        setBankAccountNumber(reduxData?.remitterAccountNumber);
        setIfscCode(reduxData?.remitterIfscCode);
        setNameasBank(reduxData?.remitterNameAsPerBank);
      }
    }
  }, [reduxData]);

  useEffect(() => {
    if (
      (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC") &&
      reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" &&
      reduxData?.service?.mechanism[0] === "cba"
    ) {
      setShowDebitorAccountDetails(true);
    }
  }, []);

  return (
    <div>
      {showDebitorAccountDetails ? null : (
        <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Bank Name</label>
            <CustomInput
              value={bankName}
              onChange={(data) => setBankName(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Bank Name"
              validator="bankName"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Name as per the bank</label>
            <CustomInput
              value={nameAsbank}
              onChange={(data) => {
                setNameasBank(data);
              }}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Name as per the bank"
              validator="alphaNumeric"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
              maxLength={50}
            />
          </div>

          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>Account Number</label>
            <CustomInput
              value={bankAccountNumber}
              onChange={(data) => setBankAccountNumber(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Account Number"
              validator="accountNumber"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>

          <div style={{ minWidth: "343px" }}>
            <label style={styles.label}>IFSC</label>
            <CustomInput
              value={ifscCode}
              onChange={(data) => setIfscCode(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="IFSC"
              validator="ifscCode"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
        </div>
      )}

      {showDebitorAccountDetails && (
        <>
          {(reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "EQUITAS") &&
            reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" && (
              <>
                <p style={{ marginBottom: "10px" }}>Revenue Account Details</p>
                <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Revenue Account Number</label>
                    <CustomInput
                      value={revenueAccNumber}
                      onChange={(data) => setRevenueAccNumber(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Revenue Account Number"
                      validator="accountNumber"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>

                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Revenue Account IFSC</label>
                    <CustomInput
                      value={revenueAccIfsc}
                      onChange={(data) => setRevenueAccIfsc(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Revenue IFSC"
                      validator="ifscCode"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                </div>
              </>
            )}

          <>
            <p style={{ marginBottom: "10px" }}>
              {reduxData?.service?.serviceProviderName?.toLowerCase() ===
              "equitas"
                ? "Equitas"
                : reduxData?.service?.serviceProviderName?.toLowerCase() ===
                  "zyro"
                ? "ICICI"
                : null}{" "}
              Debitor Account Details
            </p>
            <div style={{ display: "flex", gap: "15%", flexWrap: "wrap" }}>
              {reduxData?.service?.serviceProviderName?.toLowerCase() ===
                "zyro" && (
                <>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Corporate ID</label>
                    <CustomInput
                      value={corporateId}
                      onChange={(data) => setCorporateId(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Corporate Id"
                      validator="alphaNum"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>User ID</label>
                    <CustomInput
                      value={userId}
                      onChange={(data) => setUserId(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="User Id"
                      validator="alphaNum"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                </>
              )}

              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Debitor Account Number</label>
                <CustomInput
                  value={debitorAccNumber}
                  onChange={(data) => setDebitorAccNumber(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Debitor Account Number"
                  validator="accountNumber"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>

              <div style={{ minWidth: "343px" }}>
                <label style={styles.label}>Debitor Account IFSC</label>
                <CustomInput
                  value={debitorAccIfsc}
                  onChange={(data) => setDebitorAccIfsc(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Debitor IFSC"
                  validator="ifscCode"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            </div>
          </>
        </>
      )}

      <div
        style={{
          display: "flex",
          marginTop: "20px",
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              const ifscRegex = /^[A-Za-z]{4}[0]\w{6}$/;
              if (
                (!bankName || !nameAsbank || !bankAccountNumber || !ifscCode) &&
                !showDebitorAccountDetails
              ) {
                enqueueSnackbar("Please fill all details", {
                  variant: "error",
                });
                return;
              }
              if (bankAccountNumber && bankAccountNumber.length < 9) {
                enqueueSnackbar("Invalid account Number", {
                  variant: "error",
                });
                return;
              } else if (ifscCode && ifscRegex.test(ifscCode) === false) {
                enqueueSnackbar("Invalid ifsc code", {
                  variant: "error",
                });
                return;
              }
              if (
                reduxData?.service?.serviceType?.toLowerCase() === "payin" ||
                reduxData?.service?.serviceType?.toLowerCase() === "van" ||
                reduxData?.service?.serviceType?.toLowerCase() === "voucher" ||
                reduxData?.service?.serviceType?.toLowerCase() === "van-upi"
              ) {
                onClickNext({
                  bankName: bankName?.toUpperCase() ?? "",
                  nameAsPerBank: nameAsbank ?? "",
                  bankAccountNumber: bankAccountNumber ?? "",
                  bankIfscCode: ifscCode ?? "",
                  remitterNameAsPerBank: "",
                  remitterAccountNumber: "",
                  remitterIfscCode: "",
                });
              } else if (
                reduxData?.service?.serviceType?.toLowerCase() === "payout"
              ) {
                let equiAccounts = {};
                if (
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "equitas" ||
                  reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "zyro"
                ) {
                  if (
                    !revenueAccNumber ||
                    !revenueAccIfsc ||
                    !debitorAccIfsc ||
                    !debitorAccNumber ||
                    ifscRegex.test(revenueAccIfsc) === false ||
                    ifscRegex.test(debitorAccIfsc) === false
                  ) {
                    enqueueSnackbar("Enter Valid  details", {
                      variant: "error",
                    });
                    return;
                  }
                  if (
                    reduxData?.service?.serviceProviderName?.toLowerCase() ===
                    "zyro"
                  ) {
                    if (!corporateId || !userId) {
                      enqueueSnackbar("Enter all the detail ", {
                        variant: "error",
                      });
                      return;
                    }
                  }
                  equiAccounts = {
                    revenueAccNumber,
                    revenueAccIfsc,
                    debitorAccIfsc,
                    debitorAccNumber,
                    corpId: corporateId,
                    debUserId: userId,
                  };
                }

                if (
                  reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "ZYRO" ||
                  reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "EQUITAS"
                ) {
                  if (
                    equiAccounts.revenueAccIfsc.length !== 11 ||
                    equiAccounts.debitorAccIfsc.length !== 11
                  ) {
                    enqueueSnackbar("Please provide valid IFSC code ", {
                      variant: "error",
                    });
                    return;
                  }
                  if (
                    equiAccounts.revenueAccNumber.length < 9 ||
                    equiAccounts.debitorAccNumber.length < 9 ||
                    equiAccounts.revenueAccNumber.length > 19 ||
                    equiAccounts.debitorAccNumber.length > 19
                  ) {
                    enqueueSnackbar("Please provide valid Account Number  ", {
                      variant: "error",
                    });
                    return;
                  }
                }
                let equiAccountOfAxis = {};
                if (
                  (reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "AXIS" ||
                    reduxData?.service?.serviceProviderName?.toUpperCase() ===
                      "IDFC") &&
                  reduxData?.service?.mechanism[0] === "cba"
                ) {
                  if (debitorAccNumber.length < 9) {
                    enqueueSnackbar("Please provide valid Account Number  ", {
                      variant: "error",
                    });
                    return;
                  }
                  if (debitorAccIfsc.length !== 11) {
                    enqueueSnackbar("Please provide valid IFSC code ", {
                      variant: "error",
                    });
                    return;
                  }

                  equiAccountOfAxis.debitorAccNumber = debitorAccNumber;
                  equiAccountOfAxis.debitorAccIfsc = debitorAccIfsc;
                }

                onClickNext({
                  nameAsPerBank: "",
                  bankAccountNumber: "",
                  bankIfscCode: "",
                  bankName: bankName?.toUpperCase() ?? "",
                  remitterNameAsPerBank: nameAsbank ?? "",
                  remitterAccountNumber: bankAccountNumber ?? "",
                  remitterIfscCode: ifscCode ?? "",
                  ...equiAccounts,
                  ...equiAccountOfAxis,
                });
              }

              return;
            }}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  title: {
    fontSize: "24px",

    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  add: {
    width: "130px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "8px",
  },
};

export default BankDetails;
